import {initWebComponent} from "@/helpers/web-component-helper";
import {getToken} from "@/helpers/auth/auth-helper";

export function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}


export function getFileIconByExtension(extension) {
    let icon;
    let isImage = false;
    let isVideo = false;

    if(extension !== null) {
        switch (extension.toLowerCase()) {
            case 'DS_Store':
                icon = 'fab fa-apple';
                break;
            case 'db':
                icon = 'fa fa-database';
                break;
            case 'jpg':
            case 'png':
            case 'jpeg':
            case 'gif':
            case 'ico':
                isImage = true;
                icon = 'fa fa-image';
                break;
            case 'mov':
            case 'mp4':
                isVideo = 'video/mp4';
                icon = 'fa fa-video';
                break;
            case 'ogg':
                isVideo = 'video/ogg';
                break;
            case 'webm':
                isVideo = 'video/webm';
                break;
            case 'html':
                icon = 'fab fa-html5';
                break;
            case 'zip':
                icon = 'far fa-file-archive';
                break;
            case 'js':
            case 'map':
                icon = 'fab fa-js';
                break;
            case 'css':
                icon = 'fab fa-css3-alt';
                break;
            case 'php':
                icon = 'fab fa-php';
                break;
            case 'xml':
            case 'json':
            case 'kml':
                icon = 'fa fa-file-code';
                break;
            case 'pdf':
                icon = 'fa fa-file-pdf';
                break;
            case 'xlsx':
                icon = 'fa fa-file-excel';
                break;
            case 'csv':
                icon = 'fa fa-file-csv';
                break;
            case 'doc':
            case 'docx':
                icon = 'fa fa-file-word';
                break;
            default:
                icon = 'fa fa-file';
                break;
        }
    }

    const fileIcon = {};
    fileIcon.icon = icon;
    fileIcon.isImage = isImage;
    fileIcon.isVideo = isVideo;
    return fileIcon;
}

export async function getFileByService(url) {
    const myHeaders = new Headers();
    let token = getToken()
    if(token !== undefined) {
        myHeaders.append("Authorization", token);
    }
    const requestOptions = {
        headers: myHeaders
    };
    return fetch(url, requestOptions).then(response => {
        return response.blob();
    })
}

window.fileIndex = []

export function getFileIndexByFormID(formID, formAttributeID = undefined, onlyIndex = true) {
    let fileIndex = window.fileIndex.find(fileIndexItem => fileIndexItem.formID === formID)
    if(formAttributeID) {
        fileIndex = window.fileIndex.find(fileIndexItem =>
            fileIndexItem.formID === formID &&
            fileIndexItem.formAttributeID === formAttributeID
        )
    }

    if(formAttributeID) {
        fileIndex = window.fileIndex.find(fileIndexItem =>
            fileIndexItem.formID === formID &&
            fileIndexItem.formAttributeID === formAttributeID
        )
    }

    if(onlyIndex) {
        return fileIndex ? fileIndex.index : 0
    } else {
        return fileIndex
    }
}

export function setFileIndexByFormID(formID, formAttributeID = undefined) {

    const fileIndex = getFileIndexByFormID(formID, formAttributeID, false)

    if(!fileIndex) {
        const fileIndexItem = {
            formID: formID,
            index: 0,
            formAttributeID: formAttributeID
        }

        window.fileIndex.push(fileIndexItem)
    } else {
        fileIndex.index++
    }



}
